export enum CommonErrors {
  FAILED_LOGIN = 'Failed to login',
  FAILED_REGISTER = 'Failed to register',
  FAILED_REFRESH_TOKEN = 'Failed to refresh token',
  FAILED_TOKEN_EXPIRED = 'The token is expired',
  FAILED_FEDERATION = 'Failed federated auth',
  FAILED_RESET_PASSWORD = 'Failed to reset password code',
  FAILED_FORGET_PASSWORD = 'Failed to forget password',
  FAILED_MISSING_CODE = 'The Code is missing',
  FAILED_CONFIRM_CODE = 'Failed to confirm code',
  FAILED_LOGOUT = 'Failed logging out user',
  FAILED_USER_CONFIRMED = 'The user is not confirmed',
  FAILED_CONFIRM_RESEND = 'Failed to resend confirmation code',
  PASSWORD_RESET_REQUIRED = 'Password Reset Required: Your account requires a password reset before you can log in. Please follow these steps to regain access: Open the login page and select "Forgot Password". Enter your registered email or username. Follow the instructions sent to your email to reset your password. After resetting, try logging in again.',
  FAILED_CREDENTIALS = 'The provided credentials are incorrect. Please check and try again.',
  FAILED_PASSWORD = 'The username or password you entered is incorrect',
  FAILED_VERIFY_CAPTCHA = 'Failed to verify captcha',
  FAILED_CAPTCHA_CREDENTIALS = 'Missing recaptcha credentials',
  FAILED_EMAIL_EXISTS = 'User email already exist',
  FAILED_EMAIL_FORMAT = 'Invalid email format',
  SOMETHING_WRONG = 'Something went wrong',
  NO_AUTH_TOKEN = 'Error: No auth token', // Cognito error
  DUPLICATE_USER = 'We identified that you have a prior user with us. Please work according to the guidelines of the manual sign in first. If in the future you would like to have a Google auth account, you will be able to do it after the proper process.',
  USER_ALREADY_CONFIRMED = 'User is already confirmed',
  OTP_REQUEST_NEW_LINK = 'There was a problem with your verification link. Please request a new link.',
  AFFILIATION_COUPON_MISSING_DISCOUNT = 'This affiliation coupon is missing discount information',
  AFFILIATION_DISCOUNT_FIRST_TIME_ONLY = 'This affiliation discount is only available for first-time customers',
  CANNOT_USE_OWN_AFFILIATION_CODE = 'You cannot use your own affiliation code',
  CANNOT_ACCESS_OTHER_AFFILIATE_COUPON_CODE = 'You can only access your own affiliate coupon code',
  FAILED_GETTING_AFFILIATE_COUPON_CODE = 'Failed getting affiliate coupon code',
  USER_HAS_NO_AFFILIATE_ACCOUNT = 'User has no affiliate account',
  FAILED_SPLIT_OPERATION = 'Failed to change split',
}

export type CommonErrorKeys =
  | 'errors:failed_login'
  | 'errors:failed_register'
  | 'errors:failed_refresh_token'
  | 'errors:failed_token_expired'
  | 'errors:failed_federation'
  | 'errors:failed_reset_password'
  | 'errors:failed_forget_password'
  | 'errors:failed_missing_code'
  | 'errors:failed_confirm_code'
  | 'errors:failed_logout'
  | 'errors:failed_user_confirmed'
  | 'errors:failed_confirmation_resend'
  | 'errors:failed_credentials'
  | 'errors:failed_password'
  | 'errors:failed_verify_captcha'
  | 'errors:failed_captcha_credentials'
  | 'errors:failed_email_exists'
  | 'errors:failed_email_format'
  | 'errors:password_reset_required'
  | 'errors:something_wrong'
  | 'errors:duplicate_user'
  | 'errors:user_already_confirmed'
  | 'errors:otp_request_new_link'
  | 'errors:affiliation_coupon_missing_discount'
  | 'errors:affiliation_discount_first_time_only'
  | 'errors:cannot_use_own_affiliation_code'
  | 'errors:cannot_access_other_affiliate_coupon_code'
  | 'errors:failed_getting_affiliate_coupon_code'
  | 'errors:user_has_no_affiliate_account'
  | 'errors:failed_split_operation';

export const CommonErrorsTranslations: Record<string, CommonErrorKeys> = {
  [CommonErrors.FAILED_LOGIN]: 'errors:failed_login',
  [CommonErrors.FAILED_REGISTER]: 'errors:failed_register',
  [CommonErrors.FAILED_REFRESH_TOKEN]: 'errors:failed_refresh_token',
  [CommonErrors.FAILED_TOKEN_EXPIRED]: 'errors:failed_token_expired',
  [CommonErrors.FAILED_FEDERATION]: 'errors:failed_federation',
  [CommonErrors.FAILED_RESET_PASSWORD]: 'errors:failed_reset_password',
  [CommonErrors.FAILED_FORGET_PASSWORD]: 'errors:failed_forget_password',
  [CommonErrors.FAILED_MISSING_CODE]: 'errors:failed_missing_code',
  [CommonErrors.FAILED_CONFIRM_CODE]: 'errors:failed_confirm_code',
  [CommonErrors.FAILED_LOGOUT]: 'errors:failed_logout',
  [CommonErrors.FAILED_USER_CONFIRMED]: 'errors:failed_user_confirmed',
  [CommonErrors.FAILED_CONFIRM_RESEND]: 'errors:failed_confirmation_resend',
  [CommonErrors.FAILED_CREDENTIALS]: 'errors:failed_credentials',
  [CommonErrors.FAILED_PASSWORD]: 'errors:failed_password',
  [CommonErrors.FAILED_VERIFY_CAPTCHA]: 'errors:failed_verify_captcha',
  [CommonErrors.FAILED_CAPTCHA_CREDENTIALS]:
    'errors:failed_captcha_credentials',
  [CommonErrors.FAILED_EMAIL_EXISTS]: 'errors:failed_email_exists',
  [CommonErrors.FAILED_EMAIL_FORMAT]: 'errors:failed_email_format',
  [CommonErrors.PASSWORD_RESET_REQUIRED]: 'errors:password_reset_required',
  [CommonErrors.SOMETHING_WRONG]: 'errors:something_wrong',
  [CommonErrors.DUPLICATE_USER]: 'errors:duplicate_user',
  [CommonErrors.USER_ALREADY_CONFIRMED]: 'errors:user_already_confirmed',
  [CommonErrors.OTP_REQUEST_NEW_LINK]: 'errors:otp_request_new_link',
  [CommonErrors.AFFILIATION_COUPON_MISSING_DISCOUNT]:
    'errors:affiliation_coupon_missing_discount',
  [CommonErrors.AFFILIATION_DISCOUNT_FIRST_TIME_ONLY]:
    'errors:affiliation_discount_first_time_only',
  [CommonErrors.CANNOT_USE_OWN_AFFILIATION_CODE]:
    'errors:cannot_use_own_affiliation_code',
  [CommonErrors.CANNOT_ACCESS_OTHER_AFFILIATE_COUPON_CODE]:
    'errors:cannot_access_other_affiliate_coupon_code',
  [CommonErrors.FAILED_GETTING_AFFILIATE_COUPON_CODE]:
    'errors:failed_getting_affiliate_coupon_code',
  [CommonErrors.USER_HAS_NO_AFFILIATE_ACCOUNT]:
    'errors:user_has_no_affiliate_account',
  [CommonErrors.FAILED_SPLIT_OPERATION]: 'errors:failed_split_operation',
};
